import { AccountButton as AccountButtonBase } from "@omni/components/components/Navigation/Buttons/AccountButton/accountButton";
import { AccountButtonProps } from "@omni/types/components/props/accountButton.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";

import { AccountButtonComponent } from "@/components/Navigation/Buttons/AccountButton/accountButton.component";

export const AccountButton = ({
    // HeaderButton props
    text,
    ariaLabel,
    hiddenText,
    icon,
    link,
    invert,
    invertMobile,
    showMenuOnHover,
    alerts,

    // AccountButton props
    redirect,
    menuLinksSettings
}: AccountButtonProps<BaseStore.Etna>) => {
    return (
        <AccountButtonBase
            text={text}
            ariaLabel={ariaLabel}
            hiddenText={hiddenText}
            icon={icon}
            link={link}
            invert={invert}
            invertMobile={invertMobile}
            showMenuOnHover={showMenuOnHover}
            alerts={alerts}
            redirect={redirect}
            menuLinksSettings={menuLinksSettings}
        >
            <AccountButtonComponent />
        </AccountButtonBase>
    );
};
